/**
 * 申报主体基本信息
 */
import { any } from 'prop-types';
import DictionaryMatching from '@/components/DictionaryMatching/DictionaryMatching';

function SubjectBasicInfo({ data, dict }) {
  const year = data?.declarationYear || new Date().getFullYear();
  return (
    <>
      <div className="myapplication-detail__sub-tiny-title">申报主体基本信息</div>
      <div className="manage-detail_basic" style={{ marginBottom: 20 }}>
        <div className="myapplication-detail__grid">
          <div>
            企业名称：
            {data?.applicantName}
          </div>
          <div>
            统一社会信用代码：
            {data?.applicantNo}
          </div>
          <div>
            注册时间：
            {data?.registrationTime}
          </div>
          <div>
            注册地点：
            {data?.provinceCode}
            -
            {data?.cityCode}
            -
            {data?.areaCode}
          </div>
          <div>
            注册资本（万元）：
            {data?.registeredCapital}
          </div>
          <div>
            主要产品：
            {data?.mainProduct}
          </div>
          <div>
            法人代表：
            {data?.legalRepresentative}
          </div>
          <div>
            联系人：
            {data?.contactPerson}
          </div>
          <div>
            联系电话：
            {data?.contactPhone}
          </div>
          <div>
            联系地址：
            {data?.contactAddress}
          </div>
          <div>
            {`${year - 1}年度职工人数`}
            ：
            {data?.employeesNumber}
          </div>
          <div>
            {`${year - 1}年度营业收入（万元）`}
            ：
            {data?.operatingIncome}
          </div>
          <div>
            {`${year - 1}年利润总额（万元）`}
            ：
            {data?.grossProfit}
          </div>
          <div>
            {`${year - 1}年负债总额（万元）`}
            ：
            {data?.liabilitiesQuota}
          </div>
          <div>
            {`${year - 1}年资产总额（万元）`}
            ：
            {data?.assetsQuota}
          </div>
          <div>
            (其中：固定资产（万元）)
            ：
            {data?.fixedQuota}
          </div>
          <div>
            企业类型：
            <DictionaryMatching value={data?.enterType} dictionary={dict?.specialEnterType} />
          </div>
          <div>
            备注：
            {data?.remark}
          </div>
        </div>
        {/* <div className="myapplication-detail__grid24"> */}
        {/*  <div>备注：</div> */}
        {/*  <div>{data?.remark}</div> */}
        {/* </div> */}
      </div>
    </>
  );
}

export default SubjectBasicInfo;

SubjectBasicInfo.propTypes = {
  data: any,
  dict: any,
};
